<!--
=========================================================
* Vue Argon Dashboard 2 - v3.0.0
=========================================================

* Product Page: https://creative-tim.com/product/vue-argon-dashboard
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
-->
<template>
  <div>
    <loading-screen v-if="this.$store.state.loading === true" />
    <div
      v-show="this.$store.state.layout === 'landing'"
      class="landing-bg h-100 bg-gradient-primary position-fixed w-100"
    ></div>
    <sidenav
      :className="getSidenavClass()"
      v-if="this.$store.state.showSidenav"
    />
    <main
      class="main-content position-relative max-height-vh-100 h-100 border-radius-lg"
    >
      <div v-if="!['Signin','Signup','Verification', 'Forgot Password'].includes(this.$route.name)" class="container-fluid" style="min-height: 120px !important;">
        <breadcrumbs style="min-height: 120px;"></breadcrumbs>
      </div>
      <router-view />
      <app-footer v-show="this.$store.state.showFooter" />
      <configurator
        :toggle="toggleConfigurator"
        :class="[
          this.$store.state.showConfig ? 'show' : '',
          this.$store.state.hideConfigButton ? 'd-none' : ''
        ]"
      />
    </main>
  </div>
</template>

<style scoped>
  .no-scroll {
    overflow: hidden;
  }
</style>

<style>
.ui.search.dropdown>.text {
  max-width: 100%;
  text-wrap: nowrap;
  overflow: hidden;
}
.ui.selection.dropdown {
  width: 240px;
}
.input-group.filter {
  width: 360px;
}
.form-group.m-0.filter {
  width: 240px;
}
.input-group input.form-control {
    border-right: 1px solid #d2d6da!important;
}
a {
  color: #67748e!important;
}
.form-control.dropdown .text.default {
  color: #495057!important;
}
</style>

<script>
import Sidenav from "./examples/Sidenav";
import Configurator from "./examples/Configurator.vue";
import AppFooter from "@/examples/Footer.vue";
import { mapMutations } from "vuex";
import Breadcrumbs from "./examples/Breadcrumbs.vue";
import LoadingScreen from "@/components/LoadingScreen.vue";

export default {
  name: "App",
  components: {
    Breadcrumbs,
    Sidenav,
    Configurator,
    AppFooter,
    LoadingScreen,
  },
  async mounted() {
    await this.getSessionUser();
  },
  methods: {
    ...mapMutations(["toggleConfigurator", "navbarMinimize"]),
    getSidenavClass() {
      let classes = {}
      classes[this.$store.state.isTransparent] = true;
      classes['fixed-end'] = this.$store.state.isRTL;
      classes['fixed-start'] = !this.$store.state.isRTL;
      return classes;
    }
  },
  computed: {
    navClasses() {
      return {
        "position-sticky bg-white left-auto top-2 z-index-sticky":
          this.$store.state.isNavFixed && !this.$store.state.darkMode,
        "position-sticky bg-default left-auto top-2 z-index-sticky":
          this.$store.state.isNavFixed && this.$store.state.darkMode,
        "d-none": ["Signin","Signup","Verification"].includes(this.$route.name),
        "px-0 mx-4": !this.$store.state.isAbsolute
      };
    }
  },
  beforeMount() {
    this.$store.state.isTransparent = "bg-transparent";
  },
  watch: {
    '$store.state.loading': {
      handler: function (newVal) {
        const el = document.body
        el.style.overflow = newVal ? 'hidden' : ''
      },
      deep: true,
    },
  },
};
</script>

<style>
  .pagination-container {
    display: flex;
    column-gap: 5px;
  }
  .btn-pagination {
    padding: 0.375rem 0.75rem !important;
  }
  .btn-pagination.btn-active {
    padding: 0.375rem 0.75rem !important;
    background-color: #e9ecef !important;
    cursor: default;
  }
</style>